import {
  type HiveCssVariables,
  combinedDarkCssVariables,
  combinedLightCssVariables,
} from '@toeverything/theme';
import { unsafeCSS } from 'lit';

const toolbarColorKeys: Array<keyof HiveCssVariables> = [
  '--hive-background-overlay-panel-color',
  '--hive-v2-layer-background-overlayPanel' as never,
  '--hive-v2-layer-insideBorder-blackBorder' as never,
  '--hive-background-error-color',
  '--hive-background-primary-color',
  '--hive-background-tertiary-color',
  '--hive-icon-color',
  '--hive-icon-secondary',
  '--hive-border-color',
  '--hive-divider-color',
  '--hive-text-primary-color',
  '--hive-hover-color',
  '--hive-hover-color-filled',
];

export const lightToolbarStyles = (selector: string) => `
  ${selector}[data-app-theme='light'] {
    ${toolbarColorKeys
      .map(key => `${key}: ${unsafeCSS(combinedLightCssVariables[key])};`)
      .join('\n')}
  }
`;

export const darkToolbarStyles = (selector: string) => `
  ${selector}[data-app-theme='dark'] {
    ${toolbarColorKeys
      .map(key => `${key}: ${unsafeCSS(combinedDarkCssVariables[key])};`)
      .join('\n')}
  }
`;
